// extracted by mini-css-extract-plugin
export default {"selector":"storage-mode-select_selector__cMIWi"};